import React, {useState} from "react";
import assets from "../assets/imgs"
import InfoBox from "./InfoBox";

function MyPageAttend({style, attend = 68, absence = 0, total = 100, manager,}) {
  //logDate 는 2024.05.05 00:00 포맷

  const currentDate = getKoreanTime();

  // 원형 경로 계산
  const size = 224;
  const radius = 100; // 원의 반지름
  const circumference = 2 * Math.PI * radius; // 원의 둘레
  const leave = total - absence - attend;
  const attendRatio = manager ? ((attend - leave)/total): (attend / total);
  const absenceRatio = absence / total;

  const attendOffset = circumference - (attendRatio) * circumference;
  const absenceOffset = attendOffset - (absenceRatio) * circumference;

  return (
    <div className="commonComponent" style={{...style, padding: "32px 30px 20px 30px", display:'flex', flexDirection: 'column'}}>
      <div style={styles.headSide}>
        <div style={{display: "flex", gap: "10px", alignItems: "center",}}>
          <h1 className="font-s-head4-bold">{manager ? '금일 기업 출석률 현황' : '내 출석률 현황'}</h1>
          {manager && <InfoBox description={"총 출근 기업 수는 '출근 중 + 퇴근' 입니다."}/>}
        </div>
        <img className="icon-kebab" src={assets.icons.kebab}/>
      </div>
      <div style={styles.circularProgress}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* 회색 배경 원 */}
          <circle
            cx={size/2}
            cy={size/2}
            r={radius}
            fill="none"
            stroke="var(--grayscale_40)"
            strokeWidth="20"
          />
          {/* 노란색 결석률 원 */}
          {manager && (
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke="#FFDD9E" 
              strokeWidth="20"
              strokeDasharray={circumference}
              strokeDashoffset={absenceOffset}
              strokeLinecap="round"
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
          )}
          {/* 붉은색 퍼센트 원 */}
          <circle
            cx={size/2}
            cy={size/2}
            r={radius}
            fill="none"
            stroke="var(--primary-crimson_60)"
            strokeWidth="20"
            strokeDasharray={circumference}
            strokeDashoffset={attendOffset}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}  // 원 시작 위치를 위로 이동
          />
          
          {/* 중앙 텍스트 */}
          <text
            className="font-s-head3-semibold"
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            // fontSize={size/7.5}
            fill="var(--primary-crimson_60)"
          >
            {/* 250424 % -> 0/ 12 와 같이 변경 */}
            {/* {manager ? Math.floor((attendRatio + absenceRatio) * 100) : attendRatio * 100}% */}
            {`${attend} / ${total}`}
          </text>
        </svg>
        {manager &&(
          <div style={styles.columnManagerAttend}>
            <div style={styles.rowManagerAttend}>
              <div style={{...styles.circleManagerAttend, backgroundColor: "var(--primary-crimson_60)"}}></div>
              <p className="font-body1-semibold" style={styles.fontManagerAttendTitle}>출근 중</p>
              <p className="font-body2-medium" style={styles.fontManagerAttend}>
                <span style={styles.fontManagerAttendFirst}>{attend - leave} / </span>{total}</p>
            </div>
            <div style={styles.rowManagerAttend}>
              <div style={{...styles.circleManagerAttend, backgroundColor: "#FFDD9E"}}></div>
              <p className="font-body1-semibold" style={styles.fontManagerAttendTitle}>미출근</p>
              <p className="font-body2-medium" style={styles.fontManagerAttend}>
                <span style={styles.fontManagerAttendFirst}>{absence} / </span>{total}</p>
            </div>
            <div style={styles.rowManagerAttend}>
              <div style={{...styles.circleManagerAttend, backgroundColor: "var(--grayscale_40)"}}></div>
              <p className="font-body1-semibold" style={styles.fontManagerAttendTitle}>퇴근</p>
              <p className="font-body2-medium" style={styles.fontManagerAttend}>
                <span style={styles.fontManagerAttendFirst}>{leave} / </span>{total}</p>
            </div>
          </div>
        )}

        {/* 숫자 테스트 */}
        {/* <input
          type="number"
          value={percentage}
          onChange={(e) => setPercentage(Math.min(Math.max(e.target.value, 0), 100))} // 0~100으로 제한
          style={{
            marginTop: "20px",
            padding: "10px",
            fontSize: "16px",
            width: "100px",
          }}
        /> */}
      </div>
      {!manager && (
        <div>
          <div style={styles.divideLine}/>
          <div style={styles.footer}>
            <p className="font-body3-medium" style={styles.footerText}></p>
            <p className="font-body3-medium" style={styles.footerText}>{currentDate} 기준</p>
          </div>
        </div>
      )}
      
    </div>
  );
}

function getKoreanTime() {
  const now = new Date();
  const kstOffset = 9 * 60 * 60 * 1000; // UTC+9 (ms 단위)
  const kstTime = new Date(now.getTime() + kstOffset);

  // 년, 월, 일, 시간, 분 가져오기
  const year = kstTime.getFullYear();
  const month = String(kstTime.getMonth() + 1).padStart(2, "0"); // 01~12월
  const day = String(kstTime.getDate()).padStart(2, "0"); // 01~31일
  const hours = String(kstTime.getHours()).padStart(2, "0"); // 00~23시
  const minutes = String(kstTime.getMinutes()).padStart(2, "0"); // 00~59분

  // 형식에 맞게 문자열 생성
  const formattedTime = `${year}.${month}.${day} ${hours}:${minutes}`;
  return formattedTime;
}

const styles ={
  headSide:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "40px"
  },
  
  kebab: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  circularProgress:{
    textAlign: "center",
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    alignItems:"center", gap: "20px",
    flex: 1,
  },
  divideLine:{
    height: "1px",
    width: "100%",
    backgroundColor : "var(--grayscale_30)",
    margin: "15px 0px"
  },
  footer:{
    width: "100%",
    height: "21px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  footerText:{
    color:"var(--grayscale_60)",
  },

  columnManagerAttend:{
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    paddingLeft: "16px",
    alignItems: "flex-start"
  },
  rowManagerAttend:{
    display: "flex",
    gap: "20px",
    alignItems:"center",
    justifyContent:"center"
  },
  circleManagerAttend:{
    borderRadius: "50%",
    width: "14px", 
    height: "14px"
  },
  fontManagerAttendTitle:{
    color:"var(--grayscale_70)"
  },
  fontManagerAttend:{
    color: "var(--grayscale_90)"
  },
  fontManagerAttendFirst:{
    color: "var(--grayscale_60)"
  }
};

export default MyPageAttend;